<script setup lang="ts"></script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_446_42)">
      <path
        d="M20 10C20 4.4772 15.5228 0 10 0C4.4772 0 0 4.4772 0 10C0 14.6896 3.2288 18.6248 7.5844 19.7056V13.056H5.5224V10H7.5844V8.6832C7.5844 5.2796 9.1248 3.702 12.4664 3.702C13.1 3.702 14.1932 3.8264 14.6404 3.9504V6.7204C14.4044 6.6956 13.9944 6.6832 13.4852 6.6832C11.8456 6.6832 11.212 7.3044 11.212 8.9192V10H14.4784L13.9172 13.056H11.212V19.9268C16.1636 19.3288 20.0004 15.1128 20.0004 10H20Z"
        fill="#0866FF"
      />
      <path
        d="M13.9163 13.056L14.4775 10H11.2111V8.9192C11.2111 7.3044 11.8447 6.6832 13.4843 6.6832C13.9935 6.6832 14.4035 6.6956 14.6395 6.7204V3.9504C14.1923 3.826 13.0991 3.702 12.4655 3.702C9.12388 3.702 7.58348 5.2796 7.58348 8.6832V10H5.52148V13.056H7.58348V19.7056C8.35708 19.8976 9.16628 20 9.99908 20C10.4091 20 10.8135 19.9748 11.2107 19.9268V13.056H13.9159H13.9163Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_446_42">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
